import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { withRouter } from "react-router";
import ApiHelper from "services/api-helper";

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menus: []
    };
  }

  componentDidMount() {
    ApiHelper.GetJson('api/getMenuRole').then(res => {
      this.setState({ menus: res });
    }, error => {
      console.log(error);
    })
  }

  render() {
    return (
      <div className="sidebar">
        <nav className="sidebar-nav">
          <ul className="nav">
            {this.state.menus.map((item, idx) => (
              <li key={idx} className="nav-item">
                <Link className={item.Url === this.props.location.pathname ? "nav-link active" : "nav-link"} to={item.Url}>
                  <i className="nav-icon icon-speedometer"></i> {item.Name}
                  {/* <span dangerouslySetInnerHTML={{__html: item.Icon}}></span>{item.Name} */}
                  {/* <span className="badge badge-primary">NEW</span> */}
                </Link>
              </li>
            ))}
            {/* <li className="nav-title">Components</li>
            <li className="nav-item nav-dropdown">
              <a className="nav-link nav-dropdown-toggle" href="#">
                <i className="nav-icon icon-puzzle"></i> Base</a>
              <ul className="nav-dropdown-items">

              </ul>
            </li> */}
          </ul>
        </nav>
        <button className="sidebar-minimizer brand-minimizer" type="button"></button>
      </div>
    )
  }
}

export default withRouter(Sidebar);


// WEBPACK FOOTER //
// ./src/components/layout/sidebar.jsx